import { useEffect } from 'react';

interface UseWcfMapScrollSyncParams {
  isEnabled: boolean;
  isBlocked?: boolean;
  appRef: React.RefObject<HTMLElement | null>;
  mapRef: React.RefObject<HTMLElement | null>;
}

export const useWcfMapScrollSync = ({ isEnabled, isBlocked = false, appRef, mapRef }: UseWcfMapScrollSyncParams) => {
  useEffect(() => {
    if (!isEnabled) {
      return;
    }

    const appContainer = appRef.current;
    const mapContainer = mapRef.current;

    if (!appContainer || !mapContainer || isBlocked) {
      return;
    }

    const handleScroll = () => {
      mapContainer.style.transform = `translateY(-${Math.floor(appContainer.scrollTop || 0)}px)`;
    };

    const handleWheel = (e: WheelEvent) => {
      if (e.deltaY < 0 && !mapContainer.contains(e.target as Node)) {
        e.preventDefault();
        appContainer.scrollTo({ top: 0, behavior: 'smooth' });
      }
    };

    appContainer.addEventListener('scroll', handleScroll, { passive: false });
    appContainer.addEventListener('wheel', handleWheel, { passive: false });

    handleScroll();

    return () => {
      appContainer.removeEventListener('scroll', handleScroll);
      appContainer.removeEventListener('wheel', handleWheel);
    };
  }, [isEnabled, appRef, mapRef, isBlocked]);
};
